<template>
  <div class="my_font_style">
    <select_font_size
      type="one_level"
      :title="fontSizeTitle"
      :options="$store.state.options.fontSize"
      :value.sync="font_size"
      v-if="font_size !== undefined"
    ></select_font_size>
    <my_select type="one_level"
               :isGroup="hasCustomFont"
               :title="fontFamilyTitle"
               :options="fontFamilyOptions"
               :value.sync="font_family"
               width="250"
               v-if="font_family !== undefined"></my_select>
    <div class="setOne">
      <span v-if="title" v-text="title" class="title" :style="{ width: titleWidth+ 'px' }"></span>
      <my_color :title="$t('widgets_basic_h1_edit_577')" v-if="color_value !== undefined" class="minRight" type="one_level" :color.sync="color_value"
                :pattern.sync="patternValue" :linear_gradient.sync="linear_gradient"></my_color>
      <my_text_biu class="hideTitle" type="one_level" :fsWeight.sync="fs_weight" :fsItalics.sync="fs_italics"
                   :fsUnderline.sync="fs_underline"></my_text_biu>
      <my_text_align type="one_level" v-if="link !== undefined" :textAlign.sync="text_align"></my_text_align>
      <my_line_height type="one_level" :options="$store.state.options.lineHeight" :lineHeight.sync="line_height"
                      v-if="line_height !== undefined"></my_line_height>
      <p class="set_icon" @click="setLink" v-if="link !== undefined"><span
        class="setting_icon setting_icon_link"></span></p>
      <p class="set_icon" @click="reSet" v-if="radio_reset !== undefined"><span
        class="setting_icon setting_icon_clear"></span></p>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import select_font_size from '../my_font_size/components/select_font_size';
import {createFont} from '@/api/app.js'


export default {
  name: 'my_font_style',
  components: {
    select_font_size
  },
  props: {
    titleWidth: { // 组件的标题
      type: String,
      default: '40'
    },
    title: { // 组件的标题
      type: String,
      default: ''
    },
    textBiuTitle: {
      type: String,
      default: i18n.t('widgets_basic_h1_edit_577')
    },
    fontFamilyTitle: {
      type: String,
      default: i18n.t('widgets_basic_h1_edit_576')
    },
    fontSizeTitle: {
      type: String,
      default: i18n.t('widgets_basic_classification_edit_465')
    },
    fontSize: {},
    fontFamily: {},
    pattern: {
      type: String
    },
    linearGradient: {},
    lineHeight: {},
    colorValue: {
      type: String
    },
    selectColor: {
      type: String
    },
    fsWeight: {
      type: String
    },
    fsItalics: {
      type: String
    },
    fsUnderline: {
      type: String
    },
    textAlign: {
      type: String
    },
    lineIsShow: {
      type: String,
      default: 'true'
    },
    link: {
      type: Object
    },
    radioReset: {
      type: Object
    },
    hasCustomFont: {
      type: Boolean,
      default: false
    },
    customFont: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      font_family: this.fontFamily,
      font_size: this.fontSize,
      color_value: this.colorValue,
      select_color: this.selectColor,
      fs_weight: this.fsWeight,
      fs_italics: this.fsItalics,
      fs_underline: this.fsUnderline,
      text_align: this.textAlign,
      line_height: this.lineHeight,
      patternValue: this.pattern,
      linear_gradient: this.linearGradient,
      radio_reset: this.radioReset
    };
  },
  computed: {
    fontFamilyOptions() {
      if (!this.hasCustomFont) {
        return this.$store.state.options.fontFamilyZh
      } else {
        return [{
          label: i18n.t('components_my_font_family_index_2309'),
          options: this.$store.state.options.fontFamilyZh
        }, {
          label: i18n.t('components_my_font_family_index_2310'),
          options: this.$store.state.options.fontFamilyFree
        }]
      }
    }
  },
  methods: {
    setLink() {
      this.templet.set_link(this.link);
    },
    reSet() {
      this.font_family = i18n.t('base_kindeditor_all_1648');
      this.font_size = 20;
      this.color_value = 'rgba(51, 51, 51,1)';
      this.select_color = 'rgba(51, 51, 51,1)';
      this.fs_weight = 'normal';
      this.fs_italics = 'normal';
      this.fs_underline = 'none';
      this.text_align = 'left';
      this.line_height = i18n.t('view_back_top_edit_103');
      this.patternValue = 'pure_color';
      this.linear_gradient = {
        start_color: 'rgba(0, 0, 0,1)',
        end_color: 'rgba(0, 0, 0,1)',
        start_pointer: 12,
        end_pointer: 100,
        deg: 90
      };
    },
    createFont() {
      let widetsId = this.$store.state.app.module_Data.widgets_id
      createFont({
        originFontId: Number(this.font_family),
        keyword: $(`#u${widetsId}`).text(),
        pageName: this.$store.state.app.now_page
      }).then((res) => {
        let font = {
          name: res.data.font_face,
          url: res.data.fonts_file_url
        }
        this.$utils.insertStyle(font)
        this.$emit('update:customFont', font);
      })
    },
  },
  mounted() {
  },
  watch: {
    linear_gradient(val) {
      // 数据双向绑定
      this.$emit('update:linearGradient', val);
    },
    patternValue(val) {
      // 数据双向绑定
      console.log(val);
      this.$emit('update:pattern', val);
    },
    line_height(val) {
      // 数据双向绑定
      this.$emit('update:lineHeight', val);
    },
    font_family(val) {
      let font = [...this.$store.state.options.fontFamilyZh, ...this.$store.state.options.fontFamilyFree].find(f => f.value === val)
      if (!font.isSystem) {
        this.createFont()
      } else {
        this.$emit('update:customFont', {
          name: '',
          url: ''
        });
      }
      // 数据双向绑定
      this.$emit('update:fontFamily', val);
    },
    font_size(val) {
      // 数据双向绑定
      this.$emit('update:fontSize', val);
    },
    color_value(val) {
      // 数据双向绑定
      this.$emit('update:colorValue', val);
    },
    select_color(val) {
      // 数据双向绑定
      this.$emit('update:selectColor', val);
    },
    fs_weight(val) {
      // 数据双向绑定
      this.$emit('update:fsWeight', val);
    },
    fs_italics(val) {
      // 数据双向绑定
      this.$emit('update:fsItalics', val);
    },
    fs_underline(val) {
      // 数据双向绑定
      this.$emit('update:fsUnderline', val);
    },
    text_align(val) {
      // 数据双向绑定
      this.$emit('update:textAlign', val);
    },
    linearGradient(val) {
      this.linear_gradient = val;
    },
    pattern(val) {
      this.patternValue = val;
    },
    lineHeight(val) {
      this.line_height = val;
    },
    fontFamily(val) {
      // 数据双向绑定
      this.font_family = val;
    },
    fontSize(val) {
      // 数据双向绑定
      this.font_size = val;
    },
    colorValue(val) {
      // 数据双向绑定
      this.color_value = val;
    },
    selectColor(val) {
      // 数据双向绑定
      this.select_color = val;
    },
    fsWeight(val) {
      // 数据双向绑定
      this.fs_weight = val;
    },
    fsItalics(val) {
      // 数据双向绑定
      this.fs_italics = val;
    },
    fsUnderline(val) {
      // 数据双向绑定
      this.fs_underline = val;
    },
    textAlign(val) {
      // 数据双向绑定
      this.text_align = val;
    }
  }
};
</script>

<style scoped type="text/css" lang="scss">
.setOne {
  display: flex;
  justify-content: flex-start;
}

.my_font_style {
  margin-top: 20px;
}

.hideTitle /deep/ .title {
  display: none;
}

.minRight /deep/ .color_block {
  margin-right: 5px;
}

.title {
  display: inline-block;
  text-align: right;
  font-size: 13px;
  overflow: hidden;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/my_font_style/index.vue